import * as angular from "angular";
import * as _ from "lodash";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";
import {TaskModel} from "../../tasks/models/task.model";

export class DeliveriesAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService, private $filter) {
  }

// ******************************
//        Public methods
// ******************************

  // CREATE //
  createDeliverySuccess(delivery?, enableView?) {
    const message = {
      // body: 'X_DELIVERY_CREATE_SUCCESS'
      body: 'X_SERVICE_CREATE_SUCCESS'
    };
    const view = enableView ? 'View' : null;
    return this.bringozToastService.success(message, delivery, view)
  }

  createDeliveryError() {
    const message = {
      body: 'DELIVERY_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE - RECURRING_SERVICES //
  createRecurringServiceSuccess(service?, enableView?) {
    const payload = {
      id: service.id,
      type: this._getTranslatedValue(service, 'template.serviceType')
    }
    const message = {
      // body: 'X_DELIVERY_CREATE_SUCCESS'
      body: 'X_SERVICE_TEMPLATE_CREATE_SUCCESS'
    };
    const view = enableView ? 'View' : null;
    return this.bringozToastService.success(message, payload, view)
  }

  createRecurringServiceError() {
    const message = {
      body: 'X_SERVICE_TEMPLATE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE FIELD_SERVICE//
  createFieldServiceSuccess(delivery, enableView) {
    const message = {
      body: 'X_FIELD_SERVICE_CREATE_SUCCESS'
    };
    const view = enableView ? 'View' : null;
    return this.bringozToastService.success(message, delivery, view)
  }

  createFieldServiceError() {
    const message = {
      body: 'FIELD_SERVICE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE MANY//
  createDeliveriesSuccess() {
    const message = {
      body: 'DELIVERY_CREATE_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createDeliveriesError() {
    const message = {
      body: 'DELIVERY_CREATE_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EXPORT //
  exportSuccess() {
    const message = {
      body: 'DELIVERY_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'DELIVERY_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // VIEW SETTINGS //
  viewSettingsSuccess() {
    const message = {
      body: 'DELIVERY_VIEW_SETTINGS_SUCCESS_DETAILS',
      details: 'DELIVERY_VIEW_SETTINGS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  viewSettingsError() {
    const message = {
      body: 'DELIVERY_VIEW_SETTINGS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // BARCODE SCAN //
  barcodeScanSuccess(barcode) {
    const message = {
      body: 'X_DELIVERY_BARCODE_SCAN_SUCCESS'
    };
    return this.bringozToastService.success(message, {barcode: barcode})
  }

  barcodeScanError(barcode) {
    const message = {
      body: 'X_DELIVERY_BARCODE_SCAN_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message, {barcode: barcode})
  }

  // ASSIGN //
  assignSuccess() {
    const message = {
      body: 'DELIVERY_ASSIGN_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  assignError(error?) {
    let body;
    switch (error && error.code) {
      case 400418:
        body = 'AGENT_ASSIGN_ERROR_400418';
        break;
      default:
        body = 'DELIVERY_ASSIGN_MANY_ERROR';
        break;
    }
    const message = {
      body: body,
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  // ASSIGN MANY //
  assignManySuccess() {
    const message = {
      body: 'DELIVERY_ASSIGN_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  assignManyError(error?) {
    let body;
    switch (error && error.code) {
      case 400418:
        body = 'AGENT_ASSIGN_ERROR_400418';
        break;
      default:
        body = 'DELIVERY_ASSIGN_MANY_ERROR';
        break;
    }
    const message = {
      body: body,
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }


  // AUTO ASSIGN //
  autoAssignSuccess() {
    const message = {
      body: 'DELIVERY_AUTO_ASSIGN_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  autoAssignError() {
    const message = {
      body: 'DELIVERY_AUTO_ASSIGN_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // AUTO ASSIGN MANY //
  autoAssignManySuccess() {
    const message = {
      body: 'DELIVERY_AUTO_ASSIGN_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  autoAssignManyError() {
    const message = {
      body: 'DELIVERY_AUTO_ASSIGN_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // MANUAL HANDLED MANY //
  manualHandledManySuccess() {
    const message = {
      body: 'DELIVERY_MANUAL HANDLED_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  manualHandledManyError() {
    const message = {
      body: 'DELIVERY_MANUAL HANDLED_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD_NOTE //
  addNoteSuccess() {
    const message = {
      body: 'DELIVERY_ADD_NOTE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addNoteError() {
    const message = {
      body: 'DELIVERY_ADD_NOTE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SEND_BULK_SMS //
  sendBulkSmsSuccess() {
    const message = {
      body: 'DELIVERY_SEND_BULK_SMS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  sendBulkSmsError() {
    const message = {
      body: 'DELIVERY_SEND_BULK_SMS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE ROUTES //
  createRoutesSuccess() {
    const message = {
      body: 'DELIVERY_CREATE_ROUTES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createRoutesError() {
    const message = {
      body: 'DELIVERY_CREATE_ROUTES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ASSIGN ROUTES //
  assignRoutesSuccess() {
    const message = {
      body: 'DELIVERY_ASSIGN_ROUTES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  assignRoutesError() {
    const message = {
      body: 'DELIVERY_ASSIGN_ROUTES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SEND TO MARKET //
  sendToMarketSuccess() {
    const message = {
      body: 'DELIVERY_SEND_TO_MARKET_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  sendToMarketError() {
    const message = {
      body: 'DELIVERY_SEND_TO_MARKET_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SEND TO MARKET MANY //
  sendToMarketManySuccess() {
    const message = {
      body: 'DELIVERY_SEND_TO_MARKET_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  sendToMarketManyError() {
    const message = {
      body: 'DELIVERY_SEND_TO_MARKET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // RESET //
  resetSuccess() {
    const message = {
      body: 'DELIVERY_RESET_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  resetError() {
    const message = {
      body: 'DELIVERY_RESET_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // RESET MANY//
  resetManySuccess() {
    const message = {
      body: 'DELIVERY_RESET_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  resetManyError(error) {
    const message = {
      body: 'DELIVERY_RESET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }


  // CANCEL //
  cancelSuccess(delivery) {
    const message = {
      body: 'X_DELIVERY_CANCEL_SUCCESS'
    };
    const dropoffRef = _.find(delivery.taskList, (t) => {
      return t.taskSpec.purpose === 'Dropoff';
    });
    const address = _.get(dropoffRef, 'taskSpec.address', {});
    return this.bringozToastService.success(message, address)
  }

  cancelError() {
    const message = {
      body: 'DELIVERY_CANCEL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CANCEL MANY //
  cancelManySuccess() {
    const message = {
      body: 'DELIVERY_CANCEL_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  cancelManyError() {
    const message = {
      body: 'DELIVERY_CANCEL_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // AUCTION //
  auctionSuccess() {
    const message = {
      body: 'DELIVERY_AUCTION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  auctionError() {
    const message = {
      body: 'DELIVERY_AUCTION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // AUCTION MANY //
  auctionManySuccess() {
    const message = {
      body: 'DELIVERY_AUCTION_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  auctionManyError() {
    const message = {
      body: 'DELIVERY_AUCTION_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateDeliverySuccess(delivery) {
    const message = {
      body: 'X_DELIVERY_UPDATE_SUCCESS'
    };
    const dropoffRef = _.find(delivery.taskList, (t) => {
      return t.taskSpec.purpose === 'Dropoff';
    });
    const address = _.get(dropoffRef, 'taskSpec.address', {});
    return this.bringozToastService.success(message, address)
  }

  updateDeliveryError() {
    const message = {
      body: 'DELIVERY_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateFieldServiceSuccess(delivery) {
    const message = {
      body: 'X_FIELD_SERVICE_UPDATE_SUCCESS'
    };
    const taskRef = _.find(delivery.taskList, (t) => {
      return t.taskSpec.purpose === 'Operation';
    });
    const address = _.get(taskRef, 'taskSpec.address', {});
    return this.bringozToastService.success(message, address);
  }

  updateFieldServiceError() {
    const message = {
      body: 'FIELD_SERVICE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // COMPLETE TASK //
  completeTaskSuccess() {
    const message = {
      body: 'DELIVERY_COMPLETE_TASK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  completeTaskError() {
    const message = {
      body: 'DELIVERY_COMPLETE_TASK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // COMPLETE TASKS //
  completeTasksSuccess() {
    const message = {
      body: 'DELIVERY_COMPLETE_TASKS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  completeTasksError() {
    const message = {
      body: 'DELIVERY_COMPLETE_TASKS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CHANGE TASK STATUS //
  changeTaskStatusSuccess(task: TaskModel) {
    const message = {
      body: 'X_DELIVERY_CHANGE_TASK_STATUS_SUCCESS'
    };
    const values = {
      purpose: this._getTranslatedValue(task, 'taskSpec.purpose'),
      status: this._getTranslatedValue(task, 'status')
    };
    return this.bringozToastService.success(message, values)
  }

  changeTaskStatusError(error?) {
    const message: any = {
      body: 'DELIVERY_CHANGE_TASK_STATUS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    if (error.code === 412205) {
      message.message = 'alerts.AGENT_VEHICLE_NOT_BOUNDED_ERROR';
    }
    return this.bringozToastService.error(message)
  }

  // CANCEL TASK //
  cancelTaskSuccess(task: TaskModel) {
    const message = {
      body: 'X_DELIVERY_CANCEL_TASK_SUCCESS'
    };
    return this.bringozToastService.success(message, task)
  }

  cancelTaskError() {
    const message = {
      body: 'DELIVERY_CANCEL_TASK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPLOAD //
  uploadSuccess() {
    const message = {
      body: 'DELIVERY_UPLOAD_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  uploadError(task?) {
    const message = {
      body: 'DELIVERY_UPLOAD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message, task)
  }

  // PROGRAM_TYPE_QUOTES_EMPTY //
  programTypeQuotesSuccess() {
    const message = {
      body: 'DELIVERY_PROGRAM_TYPE_QUOTES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  programTypeQuotesEmptyError() {
    const message = {
      body: 'DELIVERY_PROGRAM_TYPE_QUOTES_EMPTY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // NO_TIME_WINDOW //
  noTimeWindowInfo() {
    const message = {
      body: 'DELIVERY_NO_TIME_WINDOW_INFO',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.info(message)
  }

  // OUT_OF_SERVICE_ZONE //
  outOfServiceZoneError() {
    const message = {
      body: 'DELIVERY_OUT_OF_SERVICE_ZONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // INVALID_DELIVERY_DAY //
  invalidDeliveryDayError() {
    const message = {
      body: 'SERVICE_INVALID_DELIVERY_DAY_ERROR'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE_RECURRING_SERVICE //
  deleteRecurringServiceSuccess() {
    const message = {
      body: 'DELIVERY_DELETE_RECURRING_SERVICE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteRecurringServiceHasResourceError(ids) {
    const message = {
      body: ids?.length > 1 ?
        'DELIVERIES_DELETE_RECURRING_SERVICES_BINDED_TO_RESOURCE_ERROR' :
        'DELIVERY_DELETE_RECURRING_SERVICE_BINDED_TO_RESOURCE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message, {id: ids ? ids[0] : undefined})
  }

  deleteRecurringServiceError() {
    const message = {
      body: 'DELIVERY_DELETE_RECURRING_SERVICE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  addToResourceAllocationSuccess() {
    const message = {
      body: 'SERVICE_ADDED_TO_ALLOCATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addToResourceAllocationError() {
    const message = {
      body: 'SERVICE_ADDED_TO_ALLOCATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  addToResourceAllocationMultiSuccess() {
    const message = {
      body: 'SERVICES_ADDED_TO_ALLOCATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addToResourceAllocationMultiError() {
    const message = {
      body: 'SERVICES_ADDED_TO_ALLOCATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_BULK //
  updateBulkSuccess() {
    const message = {
      body: 'DELIVERY_UPDATE_BULK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateBulkError() {
    const message = {
      body: 'DELIVERY_UPDATE_BULK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // BACK_IN_STORE //
  backInStoreSuccess() {
    const message = {
      body: 'BACK_IN_STORE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  backInStoreError() {
    const message = {
      body: 'BACK_IN_STORE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getTimelineError() {
    const message = {
      body: 'DELIVERY_GET_TIMELINE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //ABORT FLOW
  // assign aborted pickup single //
  assignAbortedPickupSuccess(serviceId, agentName) {

    const message = {
      body: 'THIS_SERVICE_SI_WAS_ASSIGNED_TO_AGENT_AN'
    };
    return this.bringozToastService.success(message, {SI: serviceId, AN: agentName})
  }

  // assign aborted pickup multi //
  assignAbortedPickupMultiSuccess(numOfServices, agentName) {
    const body = 'X_SERVICES_WERE_ASSIGNED_TO_AGENT_AN'
    const message = {
      body: body
    };
    return this.bringozToastService.success(message, {X: numOfServices, AN: agentName})
  }

  revertSingleSuccess(serviceId) {

    const message = {
      body: 'THE_SERVICE_SI_WAS_REVERTED'
    };
    return this.bringozToastService.success(message, {SI: serviceId})
  }

  // assign aborted pickup multi //
  revertMultiSuccess(numOfServices) {
    const body = 'X_SERVICES_WERE_REVERTED'
    const message = {
      body: body
    };
    return this.bringozToastService.success(message, {X: numOfServices})
  }

  getGlobalSearchError() {
    const message = {
      body: 'GLOBAL_SEARCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getResourceAllocationsDataError() {
    const message = {
      body: 'GET_RESOURCES_ALLOCATION_DATA_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteServiceNoteSuccess() {
    const message = {
      body: 'DELETE_NOTE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteServiceNoteError() {
    const message = {
      body: 'DELETE_NOTE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  getServiceExpensesError() {
    const message = {
      body: 'GET_SERVICE_EXPENSES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  unlinkRelatedTaskSuccess() {
    const message = {
      body: 'UNLINK_RELATED_TASK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  unlinkRelatedTaskError() {
    const message = {
      body: 'UNLINK_RELATED_TASK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  movePackagesSuccess(id: string) {
    const message = {
      body: 'MOVE_PACKAGES_SUCCESS_ID'
    };
    return this.bringozToastService.success(message, { id: id }, 'View Service');
  }

  movePackagesAndAssignSuccess(routeId: string, serviceId: string) {
    const message = {
      body: 'MOVE_PACKAGES_AND_ASSIGN_SUCCESS'
    };
    return this.bringozToastService.success(message, { routeId: routeId, serviceId: serviceId }, 'View Route');
  }

  movePackagesError() {
    const message = {
      body: 'MOVE_PACKAGES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getTranslatedValue(object, target) {
    return this.$filter('translate')(_.get(object, target))
  }

}

angular
  .module('bringoz.admin.deliveries')
  .service('deliveriesAlertsService', DeliveriesAlertsService);
